import { render, staticRenderFns } from "./MyScopes.vue?vue&type=template&id=7d56d5a7&scoped=true&"
import script from "./MyScopes.vue?vue&type=script&lang=js&"
export * from "./MyScopes.vue?vue&type=script&lang=js&"
import style0 from "./MyScopes.vue?vue&type=style&index=0&id=7d56d5a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56d5a7",
  null
  
)

export default component.exports